export const getActivityDate = (value) => {
  if (value == null || value === "") return null;

  let date;
  if (typeof value.toDate === "function") date = value.toDate();
  else if (typeof value.seconds === "number") {
    date = new Date(value.seconds * 1000 + (value.nanoseconds || 0) / 1000000);
  } else date = new Date(value);

  return Number.isFinite(date.getTime()) ? date : null;
};

const activityTime = (activity) => {
  const date = getActivityDate(activity.createdAt || activity.createDate);
  return date ? date.getTime() : 0;
};

const eventTime = (activity) => {
  if (activity.title === "bookings") {
    const date = getActivityDate(activity.startDate || activity.infoDate1);
    if (date) return date.getTime();
  }
  return activityTime(activity);
};

export const sortPatientActivities = (activities) =>
  [...activities].sort((left, right) =>
    eventTime(right) - eventTime(left) ||
    activityTime(right) - activityTime(left) ||
    String(right.actId || "").localeCompare(String(left.actId || "")),
  );
